export const TaskManagementDropDownMenuArgs = {
  ViewDetails: "VIEW-DETAILS",
  AddComment: "ADD-COMMENT",
  CompleteTask: "COMPLETE-TASK",
  CancelTask: "CANCEL-TASK",
  ReopenTask: "REOPEN-TASK",
  ReviewTask: "REVIEW-TASK",
  SwapTask_ToNew: "SWAP-TASK-TO-NEW",
  SwapTask_ToReview: "SWAP-TASK-TO-REVIEW",
};
